import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import SuccessImg from '../../elements/SuccessBox/assets/completed.png'
import { TRANSLATION } from '../../constants'
import { Service } from '../../../types'
import QuestionsPractiedImg from './assets/questions-practiced.png'
import QuestionsPracticedMobileImg from './assets/question-praticed-mobile.png'

const initialTranslation = `${TRANSLATION}.questions_practiced.initial`
const progressTranslation = `${TRANSLATION}.questions_practiced.progress`
const completedTranslation = `${TRANSLATION}.questions_practiced.completed`

export function useQuestionsPracticedConfig(props: { service: Service }) {
  const { i18n } = useI18n()
  const { isPhone } = useMediaQueries()
  const { service } = props

  const initialText = {
    badge: i18n.t(`${initialTranslation}.badge`),
    header: i18n.t(`${initialTranslation}.header`),
    subHeader: i18n.t(`${initialTranslation}.sub_header`),
    actionText: i18n.t(`${initialTranslation}.action_text`),
    imageAlt: i18n.t(`${initialTranslation}.image_alt`),
  }

  const progressText = {
    badge: i18n.t(`${progressTranslation}.badge`),
    header: i18n.t(`${progressTranslation}.header`),
    subHeader: i18n.t(`${progressTranslation}.sub_header`),
    actionText: i18n.t(`${progressTranslation}.action_text`),
    imageAlt: i18n.t(`${progressTranslation}.image_alt`),
  }

  const completedText = {
    badge: undefined,
    header: i18n.t(`${completedTranslation}.header`),
    subHeader: i18n.t(`${completedTranslation}.sub_header`),
    actionText: i18n.t(`${completedTranslation}.action_text`),
    imageAlt: i18n.t(`${completedTranslation}.image_alt`),
  }

  if (service.progress === 0) {
    return {
      status: 'initial',
      text: initialText,
      actionLink: '/interview-preparation/new',
      image: isPhone ? QuestionsPracticedMobileImg : QuestionsPractiedImg,
    }
  }

  if (service.calculatedProgress.percentageProgress >= 100) {
    return {
      status: 'completed',
      text: completedText,
      actionLink: service.getNextActionUrl() ?? '#',
      image: SuccessImg,
    }
  }

  return {
    status: 'progress',
    text: progressText,
    actionLink: '/interview-preparation/dashboard',
    image: isPhone ? QuestionsPracticedMobileImg : QuestionsPractiedImg,
  }
}
